import { useMemo } from 'react'

import {
  mapHotelTypeaheadEntriesToLocations,
  type HotelTypeaheadEntry,
} from '@/components/TripActivity/utils'
import type { CityId, LOCATION_SEARCH_TYPE } from '@/types'

import useRecommendations from './useRecommendations'

type UseHotelTypeaheadLocationsFromEntriesParams = {
  entries: ReadonlyArray<HotelTypeaheadEntry>
  isSourceFetched: boolean
}

export function useHotelTypeaheadLocationsFromEntries({
  entries,
  isSourceFetched,
}: UseHotelTypeaheadLocationsFromEntriesParams) {
  const cityIdList = useMemo<ReadonlyArray<CityId>>(
    () => entries.map((entry) => ({ label: entry.cityId })),
    [entries],
  )

  const { data: cityInfoList, isFetched: isCityInfoFetched } = useRecommendations(cityIdList)

  const isReady = isSourceFetched && (cityIdList.length === 0 || isCityInfoFetched)

  const locations = useMemo<LOCATION_SEARCH_TYPE[]>(
    () => mapHotelTypeaheadEntriesToLocations(entries, cityInfoList),
    [entries, cityInfoList],
  )

  return [locations, isReady] as const
}
